import PageLoading from './PageLoading';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Banner } from './admin-ui';
import { API_DOMAIN } from '../utils/constants';
import { syncUserTokenFromSearch } from '../utils/userToken';
import { prepareAdminEntry } from '../utils/adminEntry';
import { settingsRequest } from '../api/adminSettings';

export default function AdminEntry({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState('');
  const checkedToken = useRef('');
  useEffect(() => {
    try {
      let storage;
      try { storage = window.sessionStorage; } catch (_) { /* Optional. */ }
      const token = syncUserTokenFromSearch(location.search);
      const result = prepareAdminEntry({ location, token, apiDomain: API_DOMAIN, storage });
      if (result.redirect) { window.location.replace(result.redirect); return; }
      if (result.restore) navigate(result.restore, { replace: true });
      setReady(true);
      // Check once per app opening, including standalone entry and deep links.
      // Internal navigation and React StrictMode must not enqueue it again.
      if (token && checkedToken.current !== token) {
        checkedToken.current = token;
        settingsRequest('check-webhooks').catch(() => {
          // Maintenance runs in the background; a later entry checks again.
        });
      } else if (!token) {
        checkedToken.current = '';
      }
    } catch (e) { setError(e.message); }
  }, [location, navigate]);
  if (error) return <Banner tone="critical">{error}</Banner>;
  if (!ready) return <PageLoading label="Opening NinaCheck" message="Opening NinaCheck…" />;
  return children;
}
